import { EVENT_FORM_START, EVENT_FORM_START_DETAIL } from '~~/constants/googleTagManager';
import type { TriggerFormStartParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildFormStartTags = ({ reason }: TriggerFormStartParameters) => ({
  event: EVENT_FORM_START,
  event_info: {
    detail: EVENT_FORM_START_DETAIL,
    reason,
  },
});
